module.exports = __webpack_public_path__ + "img/PND1.52ef659a.png";